import styled from 'styled-components'

export const Wrapper = styled.main`
  display: grid;
  grid-template-areas:
    'header'
    'main';
  grid-template-rows: min-content auto 1fr;

  @media screen and (min-width: 30em) {
    grid-template-areas:
      'header'
      'main'
      'aside';
    grid-template-columns: 1fr;
  }
  @media screen and (min-width: 48em) {
    grid-template-areas:
      'aside header'
      'aside main'
      'aside main';
    grid-template-columns: 243px 1fr;
  }
`
